import { useEffect } from "react";
import { PageProps } from "@/getServerSideProps/getServerSideProps";

export const Debug = ({ pageConfig }: Pick<PageProps, "pageConfig">) => {
  useEffect(
    function exposePageConfigForDebugging() {
      window.listPageConfig = () => {
        // eslint-disable-next-line no-console
        console.table({
          "Config name": pageConfig.name,
          "Selection method": pageConfig.selectionMethod,
        });
        // eslint-disable-next-line no-console
        console.log(pageConfig);
      };
    },
    [pageConfig],
  );

  return null;
};
